import axiosClient from './axiosClient'

const errAnnouceApi = {
  create: (params) => {
    const url = '/err-annouce/create'
    return axiosClient.post(url, params)
  },
  list: (params, signal) => {
    const url = '/err-annouce/list'
    return axiosClient.get(url, { params, signal })
  },
  // delete: (ids) => {
  //   const url = `/err-annouce/delete`;
  //   return axiosClient.delete(url, { params: ids });
  // },
  update: (params) => {
    const url = '/err-annouce/update'
    return axiosClient.post(url, params)
  },
  getTotal: (params) => {
    const url = '/err-annouce/get-total-err-annouce'
    return axiosClient.get(url, { params })
  },
  delete: (invoiceIds) => {
    // debugger
    const url = `/err-annouce/delete`
    return axiosClient.delete(url, {
      data: {
        invoiceIds: invoiceIds,
      },
    })
  },
  exportById: (errorAnnoucementId, message300Id) => {
    let url = `/err-annouce/export/${errorAnnoucementId}`
    if (message300Id) {
      url = url + '?message300Id=' + message300Id
    }
    return axiosClient.get(url, { responseType: 'blob' })
  },

  hsmSignErrAnnouce: (params) => {
    const url = '/err-annouce/hsm-sign-err-annouce'

    return axiosClient.post(url, params)
  },
  listAd: (params, signal) => {
    const url = '/tax-message/accounting-documents/err-annouce/list'
    return axiosClient.get(url, { params, signal })
  },
  createAD: (params) => {
    const url = '/err-annouce/accounting-documents/create'
    return axiosClient.post(url, params)
  },
  getTotalAd: (params) => {
    const url = '/err-annouce/get-total-err-annouce-ad'
    return axiosClient.get(url, { params })
  },
  listAccountingDocument: (params, signal) => {
    const url = '/err-annouce/listAccountingDocument'
    return axiosClient.get(url, { params, signal })
  },
  updateAccountingDocument: (params) => {
    const url = '/err-annouce/updateAccountingDocument'
    return axiosClient.post(url, params)
  },
  exportByIdDocument: (errorAnnoucementId) => {
    const url = `/err-annouce/exportDocument/${errorAnnoucementId}`

    return axiosClient.get(url, { responseType: 'blob' })
  },
  hsmSignErrAnnouceDocument: (params) => {
    const url = '/err-annouce/hsm-sign-err-annouce-document'

    return axiosClient.post(url, params)
  },
}

export default errAnnouceApi
